import React from 'react';
import { Box } from '@mui/material';

const MapComponent = ()=> {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'auto', // Ensures the Box takes full width
        py: 4, // Padding top and bottom
        px: {
          xs: '1rem', // For extra-small devices
          sm: '2rem', // For small devices
          md: '3rem', // For medium devices
          lg: '4rem', // For large devices
          xl: '5rem', // For extra-large devices
        },
        margin: 'auto'
      }}
    >
      <iframe
        title="Beads Location Map Kajiado Kenya"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7975.51581158818!2d36.79141049999999!3d-1.84143785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182fc54f87cae95b%3A0x7a0c46c785a9c0e9!2sKajiado!5e0!3m2!1sen!2ske!4v1708083398346!5m2!1sen!2ske"
        width="100%"
        height="450"
        style={{ border: 0, borderRadius: '.5rem' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Box>
  );
}

export default MapComponent;
